(() => {
  const STORAGE_KEY = "roka:recently-viewed";
  const MAX_ITEMS = 12;

  const readRecentlyViewed = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];

      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const writeRecentlyViewed = (items) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
      // Storage may be unavailable in private mode.
    }
  };

  const trackProductFromJson = (product) => {
    if (!product?.id || !product?.handle) return;

    const entry = {
      id: String(product.id),
      handle: product.handle,
      title: product.title || "",
      url: product.url || `/products/${product.handle}`,
      featuredImage:
        product.featured_image ||
        product.featuredImage ||
        product.image?.src ||
        "",
      price: product.price ?? null,
    };

    const withoutCurrent = readRecentlyViewed().filter(
      (item) => item.id !== entry.id,
    );
    writeRecentlyViewed([entry, ...withoutCurrent].slice(0, MAX_ITEMS));
  };

  class RecentlyViewedTracker extends HTMLElement {
    connectedCallback() {
      const jsonNode = this.querySelector(
        "[data-recently-viewed-product-json]",
      );

      if (!jsonNode) return;

      try {
        trackProductFromJson(JSON.parse(jsonNode.textContent));
      } catch {
        // Ignore malformed product JSON.
      }
    }
  }

  if (!customElements.get("recently-viewed-tracker")) {
    customElements.define("recently-viewed-tracker", RecentlyViewedTracker);
  }

  window.RokaRecentlyViewed = {
    read: readRecentlyViewed,
    storageKey: STORAGE_KEY,
    maxItems: MAX_ITEMS,
  };
})();
